import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

class OfferCodeField extends Component {
  render() {
    console.log(this.props.offerCode)
    console.log(this.props.validation)
    return (
      <div>      
        <FormGroup>
          <Label for="offerCode">Offer Code</Label>
          <Input type="text" value={this.props.offerCode} onChange={this.props.handleChange} onBlur={this.props.validateField} name="offerCode" id="offerCode" invalid={this.props.validation.offerCode.isInvalid} maxLength="6" autoComplete="offerCode" autoCapitalize="off" autoCorrect="off" disabled={this.props.hasOfferCode}/>
          <FormFeedback>{this.props.validation.offerCode.message}</FormFeedback>
        </FormGroup>            
      </div>);
  }
}
OfferCodeField.defaultProps= {
  handleChange:() => {},
  validation: {
    offerCode: {
      isInvalid: false,
      message: ""
    }
  },
};

OfferCodeField.propTypes = {
  handleChange: PropTypes.func
};

export default OfferCodeField;


// WEBPACK FOOTER //
// ./src/components/Fields/OfferCodeField.js